/**
 * Instafeed Quick Add Modal
 *
 * Intercepts clicks on Instafeed tagged product buttons (.tagged-buy-button)
 * and opens a quick-add modal instead of navigating to the product page.
 *
 * The product ID is extracted from the onclick attribute
 * (InstafeedAPI.eventTag('product_click', 0, PRODUCT_ID))
 * and the product handle is extracted from the href attribute.
 *
 * Dependencies: components.js (ModalDialog), quick-add.js (QuickAddModal)
 */

(function () {
  'use strict';

  // Ensure window.Shopify.routes.root is set — quick-add-modal depends on it
  window.Shopify = window.Shopify || {};
  window.Shopify.routes = window.Shopify.routes || {};
  window.Shopify.routes.root = window.Shopify.routes.root || '/';

  // Open a quick-add modal for a given product
  function openQuickAddModal(productId, productHandle, triggerButton) {
    var modalId = 'instafeed-quick-add-' + productId;
    var modal = document.getElementById(modalId);

    if (!modal) {
      modal = document.createElement('quick-add-modal');
      modal.id = modalId;
      modal.className = 'sm-modal sm-quick-add-modal';
      modal.setAttribute('data-product-id', productId);
      modal.setAttribute('data-product-handle', productHandle);

      modal.innerHTML =
        '<div role="dialog" aria-label="Choose options" aria-modal="true" class="sm-modal__wrapper" tabindex="-1">' +
        '<div class="sm-modal__content">' +
        '<div class="sm-modal__body">' +
        '<div class="title-add">' +
        '<h2>Add to Cart</h2>' +
        '<button type="button" class="sm-modal__close z-10" aria-label="Close">' +
        '<svg width="20" height="20" viewBox="0 -960 960 960" fill="currentColor" xmlns="http://www.w3.org/2000/svg">' +
        '<path d="M256-227.69 227.69-256l224-224-224-224L256-732.31l224 224 224-224L732.31-704l-224 224 224 224L704-227.69l-224-224-224 224Z"/>' +
        '</svg>' +
        '</button>' +
        '</div>' +
        '<div id="quick-add-info-' + productId + '" class="sm-quick-add-modal__content-info"></div>' +
        '</div>' +
        '</div>' +
        '</div>';

      document.body.appendChild(modal);

      // Fix: QuickAddModal constructor ran when element had no children,
      // so modalContent is null. Query it now that content is in place.
      modal.modalContent = modal.querySelector('[id^="quick-add-info-"]');
      // Fix: constructor also read productHandle from dataset before
      // setAttribute was called, so it's undefined. Set it explicitly.
      modal.productHandle = productHandle;
    }

    // Lower the Instafeed lightbox z-index so our modal appears on top
    var lightbox = triggerButton.closest('.instafeed-lightbox');
    if (lightbox) {
      var originalZIndex = lightbox.style.zIndex;
      lightbox.style.zIndex = '1';
    }

    // Also lower the carousel prev/next buttons (they're often outside .instafeed-lightbox)
    var navButtons = document.querySelectorAll('.instafeed-new-arrow-prev, .instafeed-new-arrow-next');
    var navOriginalZIndexes = [];
    navButtons.forEach(function (btn) {
      navOriginalZIndexes.push(btn.style.zIndex);
      btn.style.zIndex = '1';
    });

    // Watch for modal [open] attribute removal → restore everything
    var observer = new MutationObserver(function (mutations) {
      if (!modal.hasAttribute('open')) {
        if (lightbox) {
          lightbox.style.zIndex = originalZIndex;
        }
        navButtons.forEach(function (btn, i) {
          btn.style.zIndex = navOriginalZIndexes[i];
        });
        observer.disconnect();
      }
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });

    modal.open(triggerButton);
  }

  // Delegated click listener on document for Instafeed tagged product buttons
  document.addEventListener('click', function (e) {
    var button = e.target.closest('.tagged-buy-button');
    if (!button) return;

    // Find the parent <a> tag Instafeed wraps the button in
    var link = button.closest('a');
    if (!link) return;

    // Extract product ID from onclick: InstafeedAPI.eventTag('product_click', 0, PRODUCT_ID)
    var onclickAttr = link.getAttribute('onclick');
    if (!onclickAttr) return;
    var match = onclickAttr.match(/eventTag\('product_click',\s*\d+,\s*(\d+)\)/);
    if (!match) return;
    var productId = match[1];

    // Extract product handle from href
    var href = link.getAttribute('href') || '';
    var pathMatch = href.match(/\/products\/([^/?]+)/);
    if (!pathMatch) return;
    var productHandle = pathMatch[1];

    // Prevent the link navigation
    e.preventDefault();
    // NOTE: We intentionally do NOT call stopPropagation() so Instafeed's
    // onclick tracking handler on the <a> tag still fires the tracking event.

    // quick-add-modal.open() expects a .sm-loading spinner inside the
    // opener button — Instafeed's button doesn't have one, so add it now.
    if (!button.querySelector('.sm-loading')) {
      var spinner = document.createElement('span');
      spinner.className = 'sm-loading hidden';
      button.insertBefore(spinner, button.firstChild);
    }
    // Open the quick-add modal
    openQuickAddModal(productId, productHandle, button);
  });
})();